import { render, staticRenderFns } from "./hit_change_language.vue?vue&type=template&id=72ae3770&scoped=true&"
import script from "./hit_change_language.vue?vue&type=script&lang=js&"
export * from "./hit_change_language.vue?vue&type=script&lang=js&"
import style0 from "./hit_change_language.vue?vue&type=style&index=0&id=72ae3770&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae3770",
  null
  
)

export default component.exports